import { render, staticRenderFns } from "./r-multi-tab-stage-panel.vue?vue&type=template&id=5add01e7"
import script from "./r-multi-tab-stage-panel.vue?vue&type=script&lang=js"
export * from "./r-multi-tab-stage-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5add01e7')) {
      api.createRecord('5add01e7', component.options)
    } else {
      api.reload('5add01e7', component.options)
    }
    module.hot.accept("./r-multi-tab-stage-panel.vue?vue&type=template&id=5add01e7", function () {
      api.rerender('5add01e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-multi-tab/r-multi-tab-stage-panel.vue"
export default component.exports